import { Component, Input, OnInit, SkipSelf } from '@angular/core';

import { DigitsInfo } from '../../bo/digitsInfo'
import { GlitterOfferBaseDto, CartState } from '../../api';
import { ExchangeCartService } from '../exchange-cart.service';
import { defs } from '../../defs';
import { PriceService } from '../../price.service';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

@Component({
	selector: 'narwhalia-exchange-cart-item',
	templateUrl: './exchange-cart-item.component.html',
	styleUrls: ['./exchange-cart-item.component.scss'],
	providers: [PriceService]
})
export class ExchangeCartItemComponent extends OnDestroyMixin implements OnInit {
	@Input() cartItem: GlitterOfferBaseDto;
	@Input() quantity: number;
	@Input() cartState: CartState;
	digitsInfo: DigitsInfo;
	noRemainingQty: boolean

	constructor(
		private priceService: PriceService,
		@SkipSelf() private globalPriceService: PriceService,
		private exchangeCartService: ExchangeCartService
	) {
		super();
		this.digitsInfo = defs.digitsInfo;
	}

	ngOnInit() {
		this.cartItem = GlitterOfferBaseDto.mixin(this.cartItem)
		this.noRemainingQty = this.cartItem.noRemaining()
		// this.cartItem.actualPrice = this.cartItem.price.act;
		this.priceService
			.getActualPrice(this.cartItem.price, this)
			.subscribe(actualPrice => {
				// this.cartItem.actualPrice = actualPrice;
				this.globalPriceService.priceUpdated$.next();
			});
	}

	addToCart(item: GlitterOfferBaseDto) {
		this.exchangeCartService.addItemToCart(item);
		this.noRemainingQty = this.cartItem.noRemaining()
	}

	deleteFromCart(item: GlitterOfferBaseDto) {
		this.exchangeCartService.deleteItemFromCart(item);
		this.noRemainingQty = this.cartItem.noRemaining()
	}
}